// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".community-header__thumbnail{box-shadow:0 -14px 14px rgba(0,0,0,.55)}", ""]);
// Exports
module.exports = exports;
